"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ItemQuery = (0, graphql_tag_1.default) `
  query itemQuery(
    $itemId: ID!
    $includeTerms: Boolean = false
    $termsSize: Int = 20
    $offerOptions: OfferOptionsInput
    $maxSellers: Int
    $pageSellers: Int
    $zipcode: String
  ) {
    item(
      id: $itemId
      maxSellers: $maxSellers
      pageSellers: $pageSellers
      zipcode: $zipcode
    ) {
      type
      id
      partNumber
      offerId
      image
      title
      description
      reference
      available
      isBuyBox
      path
      tags
      minimumOrderQuantity
      terms(termsSize: $termsSize) @include(if: $includeTerms)
      offers(options: $offerOptions) {
        ...offers
      }
    }
  }
`;
exports.default = ItemQuery;
